// Chaves do localStorage
export const STORAGE_KEYS = {
  ALBUMS: 'cacafigurinhas:albums',
  ACTIVE_ALBUM: 'cacafigurinhas:activeAlbum',
};

const albumStickersKey = (id) => `cacafigurinhas:album:${id}`;

export const loadAlbumStickers = (albumId) => {
  try {
    const raw = localStorage.getItem(albumStickersKey(albumId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveAlbumStickers = (albumId, data) => {
  try {
    localStorage.setItem(albumStickersKey(albumId), JSON.stringify(data));
    return true;
  } catch {
    return false;
  }
};

export const removeAlbumStickers = (albumId) => {
  try {
    localStorage.removeItem(albumStickersKey(albumId));
  } catch {}
};

// Funções de localStorage
export const loadAlbums = () => {
  try {
    const albums = localStorage.getItem(STORAGE_KEYS.ALBUMS);
    return albums ? JSON.parse(albums) : [];
  } catch (error) {
    console.error('Erro ao carregar álbuns:', error);
    return [];
  }
};

export const saveAlbums = (albums) => {
  try {
    localStorage.setItem(STORAGE_KEYS.ALBUMS, JSON.stringify(albums));
    return true;
  } catch (error) {
    console.error('Erro ao salvar álbuns:', error);
    return false;
  }
};

export const loadActiveAlbum = () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.ACTIVE_ALBUM) || null;
  } catch (error) {
    console.error('Erro ao carregar álbum ativo:', error);
    return null;
  }
};

export const saveActiveAlbum = (albumId) => {
  try {
    if (albumId) {
      localStorage.setItem(STORAGE_KEYS.ACTIVE_ALBUM, albumId);
    } else {
      localStorage.removeItem(STORAGE_KEYS.ACTIVE_ALBUM);
    }
    return true;
  } catch (error) {
    console.error('Erro ao salvar álbum ativo:', error);
    return false;
  }
};
